/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import BarraPc from "./BarraPc";

const Barra = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <BarraPc/>

        </Grid>
    )

}
export default Barra    